import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=68c858d9&scoped=true"
import script from "./activate.vue?vue&type=script&lang=js"
export * from "./activate.vue?vue&type=script&lang=js"
import style0 from "./activate.vue?vue&type=style&index=0&id=68c858d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c858d9",
  null
  
)

export default component.exports